import qs from 'qs'
import { withHeadersInstance } from './api-instance.js'
const baseUrl = process.env.VUE_APP_URL_API

export const GetPlanList = async function(parameters) {
    try {
        const queryUrl = '?' + qs.stringify(parameters)
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/plans/${queryUrl}`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}

export const CreatePlan = async function(data) {
    try {
        if (data === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: data')
            )
        return await withHeadersInstance({
            method: 'post',
            url: `${baseUrl}/plan`,
            data: data,
        })
    } catch (e) {
        console.error(e)
        return e.response
    }
}

export const GetPlan = async function(planPublicId) {
    try {
        if (planPublicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: planPublicId')
            )
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/plan/${planPublicId}`,
        })
    } catch (e) {
        console.error(e)
        return e.response
    }
}

export const UpdatePlan = async function(data) {
    try {
        const { publicId } = data
        if (data === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )
        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}/plan/${publicId}`,
            data: data,
        })
    } catch (e) {
        console.error(e)
        return e.response
    }
}

export const DeletePlan = async function(publicIds) {
    try {
        if (publicIds === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )
        return await withHeadersInstance({
            method: 'delete',
            url: `${baseUrl}/plan`,
            data: publicIds,
        })
    } catch (e) {
        console.error(e)
    }
}

export const GetPlanModules = async function(planPublicId) {
    try {
        if (planPublicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/permissions/${planPublicId}`,
        })
    } catch (e) {
        console.error(e)
    }
}

export const UpdateModule = async function(permissionModule) {
    try {
        if (permissionModule === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: permissionModule')
            )
        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}/permissions/update`,
            data: permissionModule,
        })
    } catch (e) {
        console.error(e)
    }
}

export const AddPermissions = async function() {
    try {
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/permissions/add-new`,
        })
    } catch (e) {
        console.error(e)
    }
}